import React, { useEffect } from 'react';
import { getCookie } from '../../utils/functions';
import { useNavigate } from 'react-router-dom';

let count = 0;

const Platform = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const getTokenFromCookie = () => {
      if (getCookie('platform') && getCookie('platform').split('_token=')[1]) {
        count++;
        navigate('/');
      }
    };

    const interval = setInterval(() => {
      if (count === 0) getTokenFromCookie();
    }, 1000);

    return () => clearInterval(interval); // Cleanup function
  }, [navigate]);
  return <div></div>;
};

export default Platform;
